import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestOptions } from '@angular/http/src/base_request_options';
import { Headers } from '@angular/http/src/headers';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { APIRequestOptions } from '../communication-structure/api-request';
import { LoginService } from './login.service';
import { StringTableService } from './string-table.service';


@Injectable()
export class CommunicationProxyService {
  private baseUrl;
  public isApiReady: boolean;

  constructor(private http: HttpClient, private loginService: LoginService,
    private stringTableService: StringTableService) { }

  /**
   * performs a get request and returns an observable
   * @param serviceEndpoint the endpoint of the api which should be hit
   * @param data the parameters as key value pair
   */
  read(serviceEndpoint: string, data: Object): Observable<any> {
      if ((this.isApiReady || this.stringTableService.allowGetReq) && serviceEndpoint != "assets/json/GetClientTrainingList" ) {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            serviceEndpoint += '/' + data[key];
          }
        }
        serviceEndpoint = serviceEndpoint.replace(/#/g, '%23');
        return this.http.get(this.baseUrl + serviceEndpoint, { headers: { Authorization: 'Bearer ' + this.loginService.getAccessToken() } });
      } else {
        return Observable.create((observer) => {
          this.http.get(serviceEndpoint + '.json').subscribe(
            jsonData => observer.next(jsonData),
            error => console.log(error)
          );
        });
      }
  }

  update(serviceEndpoint: string, data): Observable<any> {
    if (this.isApiReady) {
      // Not a memeber variable cause, if the token is renewed then we would need the new access token.
      // If it's a memeber and initialized only once then we may not get the new token.
      const httpOptions = ({
        headers: new HttpHeaders({
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + this.loginService.getAccessToken()
        })
      });
      return this.http.post(this.baseUrl + serviceEndpoint, data, httpOptions);
    } else {
      return Observable.create((observer) => {
        this.http.get('assets/json/response.json').subscribe(
          jsonData => observer.next(jsonData),
          error => console.log(error)
        );
      });
    }
  }

  sendPostRequest(serviceEndpoint: string, data, options?: APIRequestOptions): Observable<any> {
    if (this.isApiReady) {
      // Not a memeber variable cause, if the token is renewed then we would need the new access token.
      // If it's a memeber and initialized only once then we may not get the new token.
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + this.loginService.getAccessToken()
        })
      };

      if ( options ) {
        Object.entries( options ).forEach((value) => {
          httpOptions[value[0]] = value[1];
        });
      }

      return this.http.post( this.baseUrl + serviceEndpoint, data, httpOptions);
    }
  }

  setEndpointBaseUrl() {
    this.baseUrl = this.stringTableService.getEndpoint('apiUrl');
    this.isApiReady = this.stringTableService.getEndpoint('isApiReady');
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/services/communication-proxy.service.ts